export function getNativeVdpPayload(vehicleId?: number) {
  return JSON.stringify({
    action: 'view-vdp',
    vehicleId
  });
}

export const nativeStcPayload = JSON.stringify({
  action: 'view-trade-offer'
});

export const nativeSrpPayload = JSON.stringify({
  action: 'view-srp'
});
